import { useState } from "react";
import DJModal from "./DJModal";
import { useDjContext } from "../../context/DjContext";
import { useNavigate } from "react-router-dom";
import { handleLogout } from "../../utils/auth";
import { Menu } from "lucide-react";

const DjStatusPanel = () => {
  const {
    djId,
    token,
    isOnline,
    handleGoOffline,
    place,
    price,
    qrCodeImg,
    fetchInfo,
  } = useDjContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isQrModalOpen, setIsQrModalOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="relative flex items-center gap-4">
      <button
        onClick={() => setDropdownOpen(!dropdownOpen)}
        className="text-white px-3 py-1 rounded hover:bg-accent hover:text-black"
      >
        <Menu />
      </button>

      {dropdownOpen && (
        <div className="absolute right-0 top-full mt-5 w-48 bg-notificationList text-white rounded-lg shadow-lg z-50">
          {isOnline && (
            <div className="md:hidden block text-center border-b border-gray-600 py-2">
              <p>{place}</p>
              <p>{price} PLN</p>
            </div>
          )}

          {!isOnline ? (
            <button
              className="block w-full text-left text-accent px-4 py-2 rounded-lg hover:bg-secondary"
              onClick={() => {
                setIsModalOpen(true);
                setDropdownOpen(false);
              }}
            >
              Go Online
            </button>
          ) : (
            <div>
              <button
                className="block w-full text-left px-4 py-2 rounded-lg hover:bg-secondary"
                onClick={() => {
                  setIsQrModalOpen(true);
                  setDropdownOpen(false);
                }}
              >
                Show QR Code
              </button>
              <button
                className="block w-full text-left text-red-400 px-4 py-2 rounded-lg hover:bg-red-500 hover:text-white"
                onClick={handleGoOffline}
              >
                Go Offline
              </button>
            </div>
          )}

          <button
            className="block w-full text-left px-4 py-2 rounded-lg hover:bg-red-500"
            onClick={() => handleLogout(djId, token, navigate)}
          >
            Logout
          </button>
        </div>
      )}

      <DJModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        djId={djId}
        onStatusChange={fetchInfo}
      />

      {isQrModalOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-80 flex items-center justify-center z-50 animate-fadeIn overflow-x-hidden px-4"
          onClick={() => setIsQrModalOpen(false)}
        >
          <div
            className="bg-white p-4 rounded-xl w-full max-w-md max-w-[calc(100vw-2rem)] max-h-[calc(100vh-2rem)] flex flex-col items-center animate-scaleIn"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={qrCodeImg}
              alt="Your QR Code"
              className="w-full h-auto max-h-[70vh] object-contain"
            />
            <button
              className="mt-4 px-4 py-2 bg-accent text-black font-semibold rounded-lg"
              onClick={() => setIsQrModalOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DjStatusPanel;
